import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DateReadonlyService {
  init(): void {
    if (typeof document === 'undefined') return;

    this.processNode(document.body);

    new MutationObserver((mutations) => {
      for (const m of mutations) {
        m.addedNodes.forEach((node) => {
          if (node instanceof Element) this.processNode(node);
        });
      }
    }).observe(document.body, { childList: true, subtree: true });

    document.addEventListener('click', (e: Event) => {
      const target = e.target as Element;
      if (target.closest('mat-datepicker-toggle')) return;
      let formField: Element | null = null;

      if (target instanceof HTMLInputElement && this.isDateInput(target)) {
        formField = target.closest('mat-form-field');
      } else {
        const rangeContainer = target.closest('mat-date-range-input');
        if (rangeContainer) formField = rangeContainer.closest('mat-form-field');
      }

      if (!formField) return;

      const toggleBtn = formField.querySelector<HTMLButtonElement>('mat-datepicker-toggle button');
      if (!toggleBtn) return;
      if (toggleBtn.getAttribute('aria-expanded') !== 'true') {
        toggleBtn.click();
      }
    });
  }

  private processNode(root: Element): void {
    this.apply(root);
    root.querySelectorAll('input').forEach((el) => this.apply(el));
  }

  private isDateInput(el: Element): boolean {
    if (!(el instanceof HTMLInputElement)) return false;
    return (
      el.classList.contains('mat-datepicker-input') ||
      el.classList.contains('mat-start-date') ||
      el.classList.contains('mat-end-date') ||
      el.hasAttribute('matdatepicker') ||
      el.hasAttribute('matstartdate') ||
      el.hasAttribute('matenddate') ||
      !!el.closest('mat-date-range-input')
    );
  }

  private apply(el: Element): void {
    if (this.isDateInput(el)) (el as HTMLInputElement).setAttribute('readonly', '');
  }
}
